import { render } from "./AlphabetFilter.vue?vue&type=template&id=c9c648ca&scoped=true&ts=true"
import script from "./AlphabetFilter.vue?vue&type=script&lang=ts"
export * from "./AlphabetFilter.vue?vue&type=script&lang=ts"

import "./AlphabetFilter.vue?vue&type=style&index=0&id=c9c648ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c648ca"]])

export default __exports__